/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { workspacesModify } from "../../funcs/workspacesModify.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations.PutApiWorkspaceServiceV1WorkspacesRequestBody$inboundSchema,
};

export const tool$workspacesModify: ToolDefinition<typeof args> = {
  name: "workspaces_modify",
  description: `Update workspace`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await workspacesModify(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
